import { render, staticRenderFns } from "./Edit-permission.vue?vue&type=template&id=9c2e5824&scoped=true"
import script from "./Edit-permission.vue?vue&type=script&lang=js"
export * from "./Edit-permission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2e5824",
  null
  
)

export default component.exports